import styles from '@components/components/ReducedNavigation/components/ReducedDesktopNavigation/ReducedDesktopNavigation.module.scss';
import MainNavigation from '@components/components/Navigation/components/DesktopNavigation/components/MainNavigation/MainNavigation';
import { usePageData } from '@components/context';
import React, { useEffect, useState } from 'react';

const ReducedDesktopNavigation = () => {
  const { mainMenu: defaultMainMenu, layoutStructure } = usePageData();
  const [mainMenu, setMainMenu] = useState(defaultMainMenu);

  useEffect(() => {
    const checkForAnchorTags = () => {
      if (window.location.hash) {
        setMainMenu(currentMainMenu =>
          currentMainMenu.map(menuItem => ({
            ...menuItem,
            isActive: menuItem.url.includes(window.location.hash),
          })),
        );
      }
    };

    checkForAnchorTags();

    window.addEventListener('hashchange', checkForAnchorTags);

    return () => {
      window.removeEventListener('hashchange', checkForAnchorTags);
    };
  }, []);

  return (
    <>
      {/* Spacer element needed to achieve margin-top effect with position:sticky;  */}
      <div className={styles.spacer} role="presentation" />
      <div className={styles.container}>
        <MainNavigation
          className={styles.navigationContainer}
          isReduced
          layoutStructure={layoutStructure}
          mainMenu={mainMenu}
          noSubMenu
        />
      </div>
    </>
  );
};

export default ReducedDesktopNavigation;
